webpackJsonp([1],{

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            hideNext: false,
            hidePrev: true,
            image: '',
            images: [],
            index: 0,
            poster: '',
            modalName: '',
            mobile: window.innerWidth <= 768
        };
    },


    props: {
        items: Array,
        roomName: String,
        roomDesc: String
    },

    created: function created() {
        var _this = this;

        addEventListener('resize', function () {
            _this.mobile = innerWidth <= 768;
        });
    },
    mounted: function mounted() {
        this.images = JSON.parse(this.items);
        this.modalName = 'modal-' + this.images[0].image.id;
        this.images = this.images.map(function (el, i) {
            return {
                index: i,
                image: el.image.sizes.large
            };
        });

        this.image = this.images[0].image;
        this.poster = this.image;
        console.log(this.modalName);
    },


    methods: {
        show: function show() {
            console.log(this.mobile);
            if (!this.mobile) {
                this.$modal.show(this.modalName);
            }
        },
        hide: function hide() {
            if (!this.mobile) {
                this.$modal.hide(this.modalName);
            }
        },
        directional: function directional(direction) {
            var length = this.images.length - 1;

            if (this.index <= length && direction === 'next') {
                this.image = this.images[this.index + 1].image;
                this.hidePrev = false;

                if (this.index === length - 1) {
                    this.hideNext = true;
                }

                this.index += 1;
            } else if (this.index > 0 && direction === 'prev') {
                this.image = this.images[this.index - 1].image;
                this.hideNext = false;

                if (this.index === 1) {
                    this.hidePrev = true;
                }

                this.index -= 1;
            }
        }
    }

});

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            open: false
        };
    },


    props: ['options', 'currentLocation'],

    methods: {
        gotosite: function gotosite(url) {
            window.location = url;
        }
    }
});

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            weeks: {},
            submitting: false,
            success: false
        };
    },


    methods: {
        submitForm: function submitForm(event) {
            var _this = this;

            this.submitting = true;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(BAStarter.resturl + 'wp/v2/truck-schedule/update', {
                weeks: this.weeks
            }, {
                headers: {
                    'X-WP-Nonce': BAStarter.restnonce
                }
            }).then(function (response) {
                _this.submitting = false;
                _this.success = true;
                setTimeout(function () {
                    _this.success = false;
                }, 2000);
                console.log(response);
            });
        }
    },

    mounted: function mounted() {
        for (var ref in this.$refs) {
            this.weeks[ref] = this.$refs[ref].getAttribute('data-value');
        }
        this.$forceUpdate();
    }
});

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(38),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(37),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(30),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-switch"
  }, [_c('div', {
    staticClass: "site-switch__current",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentLocation)
    }
  }), _vm._v(" Location\n        "), _c('span', {
    staticClass: "site-switch__chevron"
  })]), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "site-switch__options"
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      staticClass: "site-switch__option",
      domProps: {
        "innerHTML": _vm._s(option.name)
      },
      on: {
        "click": function($event) {
          _vm.gotosite(option.url)
        }
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "booking__room"
  }, [(!_vm.mobile) ? [_c('modal', {
    attrs: {
      "name": _vm.modalName,
      "width": 800,
      "height": 450
    }
  }, [_c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel__primary"
  }, [_c('div', {
    staticClass: "carousel__media"
  }, [_c('div', {
    staticClass: "carousel__image",
    style: ({
      backgroundImage: ("url(" + _vm.image + ")")
    }),
    on: {
      "click": _vm.show
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel__arrows-container"
  }, [(!_vm.hidePrev) ? [_c('svg', {
    staticClass: "carousel__arrows carousel__arrows--prev",
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.directional('prev')
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20",
      "cy": "20",
      "r": "19.5",
      "fill": "white",
      "stroke": "#DADDDF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 14L23 20L17 26",
      "stroke": "#C45F24",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])] : _vm._e(), _vm._v(" "), (!_vm.hideNext) ? [_c('svg', {
    staticClass: "carousel__arrows carousel__arrows--next",
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.directional('next')
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20",
      "cy": "20",
      "r": "19.5",
      "fill": "white",
      "stroke": "#DADDDF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 14L23 20L17 26",
      "stroke": "#C45F24",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])] : _vm._e()], 2)])])])] : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "booking__title",
    domProps: {
      "innerHTML": _vm._s(_vm.roomName)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "booking__image-container",
    on: {
      "click": _vm.show
    }
  }, [_c('div', {
    staticClass: "booking__image",
    style: ({
      backgroundImage: ("url(" + _vm.poster + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "booking__see-more"
  }, [_vm._v("See more photos!")])]), _vm._v(" "), _c('div', {
    staticClass: "booking__carousel-mobile"
  }, [_c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel__primary"
  }, [_c('div', {
    staticClass: "carousel__media"
  }, [_c('div', {
    staticClass: "carousel__image",
    style: ({
      backgroundImage: ("url(" + _vm.image + ")")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel__arrows-container"
  }, [(!_vm.hidePrev) ? [_c('svg', {
    staticClass: "carousel__arrows carousel__arrows--prev",
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.directional('prev')
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20",
      "cy": "20",
      "r": "19.5",
      "fill": "white",
      "stroke": "#DADDDF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 14L23 20L17 26",
      "stroke": "#C45F24",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])] : _vm._e(), _vm._v(" "), (!_vm.hideNext) ? [_c('svg', {
    staticClass: "carousel__arrows carousel__arrows--next",
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.directional('next')
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20",
      "cy": "20",
      "r": "19.5",
      "fill": "white",
      "stroke": "#DADDDF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 14L23 20L17 26",
      "stroke": "#C45F24",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])] : _vm._e()], 2)])])]), _vm._v(" "), _c('p', {
    staticClass: "booking__info",
    domProps: {
      "innerHTML": _vm._s(_vm.roomDesc)
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(8);
module.exports = __webpack_require__(9);


/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Room__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TruckScheduleAdmin_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TruckScheduleAdmin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_TruckScheduleAdmin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SiteSwitch_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SiteSwitch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SiteSwitch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_modal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_js_modal__);






var VueScrollTo = __webpack_require__(39);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueScrollTo);

window.Vue = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_js_modal___default.a);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',

    components: {
        SiteSwitch: __WEBPACK_IMPORTED_MODULE_3__components_SiteSwitch_vue___default.a,
        TruckScheduleAdmin: __WEBPACK_IMPORTED_MODULE_2__components_TruckScheduleAdmin_vue___default.a,
        Room: __WEBPACK_IMPORTED_MODULE_1__components_Room___default.a
    }
});

var navToggle = document.getElementById('nav-toggle');
var primaryNav = document.getElementById('primary-nav');

navToggle.addEventListener('click', toggleNavbar);

function toggleNavbar() {
    var _this = this;

    this.classList.toggle('masthead__nav-toggle--open');
    if (!this.classList.contains('masthead__nav-toggle--open')) {
        primaryNav.classList.remove('primary-nav--open');
        this.classList.add('masthead__nav-toggle--closing');
        this.removeEventListener('click', toggleNavbar);

        setTimeout(function () {
            _this.classList.remove('masthead__nav-toggle--closing');
            _this.addEventListener('click', toggleNavbar);
        }, 500);
    } else {
        primaryNav.classList.add('primary-nav--open');
    }
}

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[43]);


// WEBPACK FOOTER //
// js/app.js